import { version } from 'react';

const isAtLeastReact19 = +version.split('.', 1)[0] >= 19;
/** If you need to set the `inert` (see
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/inert)
 * attribute on an HTML element, use this value
 *
 * Pre-react-18 you set `inert` by doing `inert=""`, but from react 19 onwards,
 * you need to do `inert={true}` instead.
 *
 * This value feature-checks for `React.useId`, which was introduced in react 19
 * and exports `inert` as either `""` or `true` accordingly
 **/
const inert = (isAtLeastReact19 ? true : '');

export { inert };
//# sourceMappingURL=inert.js.map
